/**
 * Listings by id, for lists the buyer keeps (cart, favorites, the cart badge).
 *
 * One listings query takes at most 100 ids and returns at most 100 listings,
 * so a longer list is asked for in groups of 100. The answer has the shape of
 * one query's answer (data, included, meta), so it goes to
 * addMarketplaceEntities as it is.
 */
export const MAX_IDS_PER_QUERY = 100;

const inGroups = (ids, size) => {
  const groups = [];
  for (let i = 0; i < ids.length; i += size) {
    groups.push(ids.slice(i, i + size));
  }
  return groups;
};

export const queryListingsByIds = (sdk, ids, params = {}) => {
  const groups = inGroups(ids || [], MAX_IDS_PER_QUERY);
  return Promise.all(
    groups.map(group =>
      sdk.listings.query({ ...params, ids: group, page: 1, perPage: MAX_IDS_PER_QUERY })
    )
  ).then(responses => {
    const data = responses.flatMap(r => r?.data?.data || []);
    const included = responses.flatMap(r => r?.data?.included || []);
    return {
      ...(responses[0] || {}),
      data: {
        data,
        included,
        meta: { totalItems: data.length, totalPages: 1, page: 1, perPage: data.length },
      },
    };
  });
};
